import React from 'react';
import { useIntl } from 'react-intl-next';
import { HeadingItem, Section } from '@atlaskit/menu';
import { ListItemMenuOption } from '../../../list-item-menu-option';
import type { CustomOptionsProps } from '../../types';
import { renderOverrideLabel } from '../../utils';

const CustomOptions = ({
	id,
	customOtherSections,
	onCreateTriggerClick,
	setCloseMenu,
	setInitialFocusRef,
	setOpenModal,
	renderListItemMenuOption,
}: CustomOptionsProps) => {
	const { formatMessage } = useIntl();
	return (
		<>
			{customOtherSections.map(({ id: sectionId, title, options }) => {
				if (!options || options.length === 0) {
					return null;
				}
				return (
					<Section
						testId={`roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.custom-options.${sectionId}`}
						key={sectionId}
						hasSeparator
					>
						{title && <HeadingItem>{renderOverrideLabel(formatMessage, title)}</HeadingItem>}
						{options.map(({ id: optionId }, index) => (
							<div key={optionId}>
								{renderListItemMenuOption({
									id,
									optionId,
									setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
									setOpenModal: (event) => {
										setOpenModal(event, optionId);
									},
									Option: ListItemMenuOption,
									onCreateTriggerClick,
									setCloseMenu,
								})}
							</div>
						))}
					</Section>
				);
			})}
		</>
	);
};

export default CustomOptions;
